import {createAction} from "./base";

const GetDefaultSmtpConfigurationAction = createAction('GetDefaultSmtpConfigurationAction');
const FetchPermissionsAction = createAction('FetchPermissionsAction');
const FetchRolesAction = createAction('FetchRolesAction');
const GetInitDataAction = createAction('GetInitDataAction');
const SearchProjectAction = createAction('SearchProjectAction');
const GetMainPageProjectsAction = createAction('GetMainPageProjectsAction');
const GetTermsOfUseAction = createAction('GetTermsOfUseAction');
const UnloadAppAction = createAction('UnloadAppAction');
const SetPageSizeAction = createAction('SetPageSizeAction');
const GetApplicationImagesAction = createAction('GetApplicationImagesAction');
const SetArchivePageSizeAction = createAction('SetArchivePageSizeAction');
const GetMainPageProbeProjectsAction = createAction('GetMainPageProbeProjectsAction');
const SetExpandStateItemAction = createAction('SetExpandStateItemAction');
const SetBreadcrumbsAction = createAction('SetBreadcrumbsAction');

function getDefaultSmtpConfiguration() {
	return {
		type: GetDefaultSmtpConfigurationAction.Request
	};
}

function fetchPermissions() {
	return {
		type: FetchPermissionsAction.Request
	};
}

function fetchRoles() {
	return {
		type: FetchRolesAction.Request
	};
}

function getInitData() {
	return {
		type: GetInitDataAction.Request
	};
}

function searchProject(search) {
	return {
		type: SearchProjectAction.Request,
		payload: search
	};
}

function getMainPageProjects() {
	return {
		type: GetMainPageProjectsAction.Request
	};
}

function getTermsOfUse(id) {
	return {
		type: GetTermsOfUseAction.Request,
		payload: id
	};
}

function unloadApp() {
	return {
		type: UnloadAppAction.Request
	};
}

function setPageSize(size) {
	return {
		type: SetPageSizeAction.Request,
		payload: size
	};
}

function getApplicationImages() {
	return {
		type: GetApplicationImagesAction.Request,
	};
}


function setArchivePageSize(size) {
	return {
		type: SetArchivePageSizeAction.Request,
		payload: size
	};
}

function getMainPageProbeProjects() {
	return {
		type: GetMainPageProbeProjectsAction.Request,
	}
}

function setExpandStateItem(action, property, id) {
	return {
		type: SetExpandStateItemAction.Request,
		payload: {
			action, property, id
		}
	}
}
function setBreadcrumbs(breadcrumbs) {
	return {
		type: SetBreadcrumbsAction.Request,
		payload: breadcrumbs
	}
}

export const AppActionCreators = {
	getDefaultSmtpConfiguration,
	fetchPermissions,
	fetchRoles,
	getInitData,
	searchProject,
	getMainPageProjects,
	getTermsOfUse,
	unloadApp,
	setPageSize,
	getApplicationImages,
	setArchivePageSize,
	getMainPageProbeProjects,
	setExpandStateItem,
	setBreadcrumbs
};

export const AppActions = {
	GetDefaultSmtpConfigurationAction,
	FetchPermissionsAction,
	FetchRolesAction,
	GetInitDataAction,
	SearchProjectAction,
	GetMainPageProjectsAction,
	GetTermsOfUseAction,
	UnloadAppAction,
	SetPageSizeAction,
	GetApplicationImagesAction,
	SetArchivePageSizeAction,
	GetMainPageProbeProjectsAction,
	SetExpandStateItemAction,
	SetBreadcrumbsAction
};
